/// <reference path="../../Controls/CertificateDialog/UploadPrivateKey/UploadPrivateKey.ts"/>

module EEX.McEc.Apps {

    import SetPrivateKeyPasswordModel = McEc.Controls.CertificateDialog.SetPrivateKeyPasswordModel;
    import SetPrivateKeyPasswordView = McEc.Controls.CertificateDialog.SetPrivateKeyPasswordView;
    import CreatePrivateKeyModel = McEc.Controls.CertificateDialog.CreatePrivateKeyModel;
    import CreatePrivateKeyView = McEc.Controls.CertificateDialog.CreatePrivateKeyView;
    import UploadCsrAndRequestCertificateModel = McEc.Controls.CertificateDialog.UploadCSRAndRequestCertificateModel;
    import UploadCsrAndRequestCertificateView = McEc.Controls.CertificateDialog.UploadCSRAndRequestCertificateView;
    import SavePkcsFileModel = McEc.Controls.CertificateDialog.SavePkcsFileModel;
    import SavePkcsFileView = McEc.Controls.CertificateDialog.SavePkcsFileView;
    import CertificateDialogModel = McEc.Controls.CertificateDialog.CertificateDialogModel;
    import SetPKCSFilePasswordModel = McEc.Controls.CertificateDialog.SetPKCSFilePasswordModel;
    import SetPKCSFilePasswordView = McEc.Controls.CertificateDialog.SetPKCSFilePasswordView;
    import SavePrivateKeyModel = McEc.Controls.CertificateDialog.SavePrivateKeyModel;
    import SavePrivateKeyView = McEc.Controls.CertificateDialog.SavePrivateKeyView;
    import UserInfo = AppKitchen.Api.Models.UserInfo;
    import CreatePrivateKeyCommand = McEc.Commands.CreatePrivateKeyCommand;
    import RequestCertificateCommand = McEc.Commands.RequestCertificateCommand;
    import SavePrivateKeyToFileCommand = McEc.Commands.SavePrivateKeyToFileCommand;
    import CreateAndSavePkcsFileCommand = McEc.Commands.CreateAndSavePkcsFileCommand;
    import CertificateModel = McEc.Domain.CertificateModel;
    import UploadPrivateKeyModel = McEc.Controls.CertificateDialog.UploadPrivateKeyModel;
    import UploadPrivateKeyView = McEc.Controls.CertificateDialog.UploadPrivateKeyView;
    import ReadPrivateKeyFileCommand = McEc.Commands.ReadPrivateKeyFileCommand;
    import GetKeyPairFromFileCommand = McEc.Commands.GetKeyPairFromFileCommand;

    // ReSharper disable once InconsistentNaming
    export interface CertificateDownloadDialogOptions extends AppKitchen.AppBaseOptions {
        userInfo?: UserInfo,
        authorityId?: string,
        certificateKey?: number,
        store?: Pki.Store,
        certificateFile?: string,
        close?: (certificateKey: number, store: Pki.Store, certificateFile: string) => void,
    }

    export class CertificateDownloadDialogApp extends AppKitchen.AppBase<CertificateDownloadDialogOptions> {

        public start() {
            let model = new CertificateDialogModel({
                userInfo: this.options.userInfo,
                certificateKey: this.options.certificateKey,
                store: this.options.store,
                certificateFile: this.options.certificateFile,
                currentProcessStep: 1,
                totalProcessSteps: 3,
            });

            let createAndSavePkcsFileCommand = new CreateAndSavePkcsFileCommand();
            let getKeyPairFromFileCommand = new GetKeyPairFromFileCommand();
            let readPrivateKeyFileCommand = new ReadPrivateKeyFileCommand();

            let uploadPrivateKeyModel = new UploadPrivateKeyModel(model, 1, readPrivateKeyFileCommand, getKeyPairFromFileCommand);
            let uploadPrivateKeyView = new UploadPrivateKeyView(uploadPrivateKeyModel, this.el);

            let setPkcsFilePasswordModel = new SetPKCSFilePasswordModel(model, 2);
            let setPkcsFilePasswordView = new SetPKCSFilePasswordView(setPkcsFilePasswordModel, this.el);

            let savePkcsFileModel = new SavePkcsFileModel(model, 3, createAndSavePkcsFileCommand);
            let savePkcsFileView = new SavePkcsFileView(savePkcsFileModel, this.el);

            uploadPrivateKeyView.next(() => {
                setPkcsFilePasswordView.render();
            });

            setPkcsFilePasswordView.next(() => {
                savePkcsFileView.render();
            });

            savePkcsFileView.finish(() => {
                let certificateKey = model.get().certificateKey;
                let store = model.get().store;
                let certificateFile = model.get().certificateFile;
                this.options.close(certificateKey, store, certificateFile);
            });

            if (this.options.store) {
                setPkcsFilePasswordView.render();
            } else {
                uploadPrivateKeyView.render();
            }
        }
    }
}